import { formatDate } from '@mi-front/core';
import { useCallback } from 'react';
import { useTimezone } from './useTimezone';

type FormatDateValue = Parameters<typeof formatDate>[0];

/**
 * Returns a formatter bound to the active timezone (station context, else browser).
 * Prefer this over `formatDate(..., tz)` when formatting strings in React.
 * Keep `useTimezone()` when you need the raw IANA id for DayPicker, moment chaining, etc.
 * Pass `overrideTz` only when formatting in a timezone other than the context (e.g. LDate `tz` prop).
 */
export function useTzFormat() {
  const tz = useTimezone();

  return useCallback(
    (value: FormatDateValue, format: string, overrideTz?: string) =>
      formatDate(value, format, overrideTz ?? tz),
    [tz],
  );
}
